import {gql} from "apollo-angular";
import {baseResponse} from "../../../base.graphql";


export const feedbackCategoryFields = `
    id
    categoryUniqueId
    categoryName
`;



export const GET_CITI_ALL_FEEDBACK_CATEGORIES = gql`
    query CitizenGetAllFeedbackCategories {
        citizenGetAllFeedbackCategories {
            response {
                ${baseResponse}
            }
            data {
                ${feedbackCategoryFields}
            }
        }
    }
`;
